// Status code constants and dropdown options

import type { BatchPriority, EntityType } from './core';

/**
 * Workflow status codes.
 */
export const WorkflowStatusCodes = {
  NEW: 'NEW',
  AWAITING_PO: 'AWAITING_PO',
  AWAITING_IMPORT: 'AWAITING_IMPORT',
  AWAITING_REVIEW: 'AWAITING_REVIEW',
  AWAITING_SEND: 'AWAITING_SEND',
  AWAITING_INVOICE: 'AWAITING_INVOICE',
  COMPLETED: 'COMPLETED',
} as const;

export type WorkflowStatusCode =
  (typeof WorkflowStatusCodes)[keyof typeof WorkflowStatusCodes];

// Priority options for dropdowns
export const PriorityOptions: { value: BatchPriority; label: string }[] = [
  { value: 'Urgent', label: 'Urgent' },
  { value: 'High', label: 'High' },
  { value: 'Normal', label: 'Normal' },
  { value: 'Low', label: 'Low' },
];

// Entity type options for dropdowns
export const EntityTypeOptions: { value: EntityType; label: string }[] = [
  { value: 'Farmer', label: 'Farmer' },
  { value: 'Agent', label: 'Agent' },
  { value: 'Lab', label: 'Lab' },
  { value: 'Partner', label: 'Partner' },
];

// Entity assignment role constants
export const ENTITY_ROLES = {
  CLIENT: 'Client',
  SUPPLIER: 'Lab',
  /** Legacy (DRI-85): shown read-only, no longer assignable. */
  RECOMMENDATION_RECIPIENT: 'Recommendation Recipient',
  /** Legacy (DRI-85): shown read-only, no longer assignable. */
  PDF_REPORT_RECIPIENT: 'PDF Report Recipient',
  BRAND: 'Brand',
  SALES_AGENT: 'Sales Agent',
} as const;

export type EntityRole = (typeof ENTITY_ROLES)[keyof typeof ENTITY_ROLES];
